module.exports = "switch {\n  border: 0;\n  padding-left: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/settings/companies/components/company.modal.scss
// module id = 581
// module chunks = 1